const apiDoctores =
  "/doctores.php";

export default apiDoctores;
